import { QueryClientConfig } from "@tanstack/react-query";
import { ClientError } from "../models/ClientError";

// Handler function for retries in React Query.
function retryHandler(failureCount: number, errorObj: Error): boolean {
  if (failureCount >= 3) {
    return false;
  }

  const error = errorObj as ClientError;

  if (!error.status) {
    return true;
  }

  // Handle status codes that we don't want to retry on.
  switch (error.status) {
    case 400: // Bad Request
      return false;
    case 401: // Unauthorized
      return false;
    case 403: // Forbidden
      return false;
    case 404: // Page Not Found
      return false;
    case 405: // Method Not Allowed
      return false;
    case 500: // Internal Server Error
      return false;
    default:
      return true;
  }
}

export const reactQueryClientConfig: QueryClientConfig = {
  defaultOptions: {
    queries: {
      retry: retryHandler,
      staleTime: 120000, // 2 min.
      throwOnError: true,
    },
    mutations: {
      retry: retryHandler,
      throwOnError: true,
    },
  },
};
